import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import getLocal from '@/app/utils/i18n';

interface ItemType {
    img: [string, string];
    text: string;
}
export default function Comp() {
    const { t } = useLang('theProduct.SectionM');
    const { locale = 'us' } = getLocal();
    const IS_JP_SITE = ['jp'].includes(locale);
    const items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1744769669791/M1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1744769669609/M1-h5.jpg'],
            text: t('item1'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1744769670214/M2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1744769823926/M2-h5.jpg'],
            text: t('item2'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1744769670743/M3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1744769670935/M4-h5.jpg'],
            text: t.rich('item3', {
                sup: (v: string) => <sup className="mini-sup">{v}</sup>,
            }),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1744769671156/M4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1744769670410/M3-h5.jpg'],
            text: t.rich('item4', {
                sup: (v: string) => <sup className="mini-sup">{v}</sup>,
            }),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1744769671500/M5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1744769671318/M5-h5.jpg'],
            text: t('item5'),
        },
    ];

    return (
        <div className={styles.comp} id="sectionM">
            <EcoSpace className="spec-x" />
            <h2 className="eco-content comp-title1">{t('title1')}</h2>
            <EcoSpace className="spec-m" />
            {t('title2') && (
                <>
                    <EcoSectionCommon title={t('title2')} />
                    <EcoSpaceSmall />
                </>
            )}
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li key={k} className={`item item-${k + 1}`} style={{ gridArea: `x${k + 1}` }}>
                        <div className="item-box">
                            <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} className="item-img" isOpenLazy />
                            <p className="item-text">{item.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <EcoSpace />
            <EcoSectionCommon sectionCommonLayout="left" title={t('title3')} desc={t('desc3')} />
            <EcoSpaceSmall />
            <EcoImg
                pc={
                    IS_JP_SITE
                        ? 'https://websiteoss.ecoflow.com/upload/image/1745378882118/M6p.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1744769671859/M6.jpg'
                }
                pad={
                    IS_JP_SITE
                        ? 'https://websiteoss.ecoflow.com/upload/image/1745378882118/M6p.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1744769671859/M6.jpg'
                }
                h5={
                    IS_JP_SITE
                        ? 'https://websiteoss.ecoflow.com/upload/image/1745378882316/M6-h5.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1744769671685/M6-h5.jpg'
                }
                className="eco-content comp-img3"
            />
            <EcoSpace />
        </div>
    );
}
